import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.scss'

function UserDetail({ name, role, commonInterestCount, isLoggedUser }) {
  const { t } = useTranslation()
  return (
    <div className={styles.detailContainer}>
      <h1 className={styles.name}>{name}</h1>
      <h2 className={styles.roleAndInterests}>
        {`${role}${role && commonInterestCount > 0 ? ` | ` : ''}${
          commonInterestCount > 0
            ? isLoggedUser
              ? `${t('profile_light.interestCount', { count: commonInterestCount })}`
              : `${t('profile_light.commonInterests', { count: commonInterestCount })}`
            : ''
        }`}
      </h2>
    </div>
  )
}

export default UserDetail
